// React
import { useEffect, useState, useRef } from "react";

// Libraries
import moment from "moment";
import { isEmpty, map, get, find } from "lodash";

// Utils
import { getTimeStamp, getAgentTimestamp } from "@Utils/functionality";

const useAlert = (chat, defaultAlerts, isHistoric = false) => {
	const timeoutRef = useRef(null);
	const [alert, setAlert] = useState({
		color: "blue",
		time: 0,
		name: "A Tiempo",
	});

	useEffect(() => {
		const currentTab = get(chat, "newChat") ? "Nuevo" : get(chat, "message.sentByAgent") ? "Cliente" : "Atender";
		if (isEmpty(chat) || isHistoric || currentTab === "Cliente") {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
			const mappedAlerts = map(defaultAlerts, (item) => {
				return { ...item, time: item.time * 60000 };
			});
			const foundAlert = find(mappedAlerts, { name: get(chat, "closeState", "A Tiempo") });
			setAlert(foundAlert || { color: "blue", time: 0, name: "A Tiempo" });
			return;
		}

		const currentTime = getTimeStamp();
		const lastTimeStamp = getAgentTimestamp(chat.messages);
		const diffDateMessage = moment.duration(moment(currentTime).diff(moment(lastTimeStamp))).asMilliseconds();

		const alertSource = get(chat, "group.settings.alerts", defaultAlerts);
		const mappedAlerts = map(alertSource, (item) => {
			return { ...item, time: item.time * 60000 };
		});
		let index = 0;
		if (diffDateMessage >= mappedAlerts[2]?.time) {
			index = 2;
		} else if (diffDateMessage >= mappedAlerts[1]?.time) {
			index = 1;
		} else {
			index = 0;
		}

		setAlert(mappedAlerts[index] || { color: "blue", time: 0, name: "A Tiempo" });
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}

		if (index < 2 && mappedAlerts[index + 1]) {
			const nextAlertTime = mappedAlerts[index + 1].time;
			const timeUntilNext = Math.max(0, nextAlertTime - diffDateMessage);
			timeoutRef.current = setTimeout(() => {
				setAlert({ ...mappedAlerts[index + 1] });
			}, timeUntilNext);
		}

		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, [get(chat, "id", 0), get(chat, "message.id", 0), isHistoric, alert?.name]);

	return alert;
};

export default useAlert;